import styled from 'styled-components';
import { BadgeDark } from '@comeon/ui';

const ParticipantsText = styled(BadgeDark)`
	background-color: rgba(var(--base-12), 0.8);
	display: inline-flex;
	font-size: 11px;
	color: rgba(var(--font-light), 1);
	padding: 2px 4px;

	svg {
		height: 11px;
		width: 11px;
		margin-right: 3px;
	}
`;

export default ParticipantsText;
